import { uploadToServer } from "../utils/uploadToServer";

export default class ModelBlock {
  constructor({ data }) {
    this.data = data || { src: "", alt: "3D Model" };
    this.wrapper = null;
  }

  render() {
    this.wrapper = document.createElement("div");

    const info = document.createElement("p");
    info.textContent = "Max. 15 MB • Format: glb, gltf";

    const input = document.createElement("input");
    input.placeholder = "https://example.com/model.glb";
    input.type = "text";
    input.value = this.data.src;
    input.className = "w-full border p-2 rounded mb-2";

    const fileInput = document.createElement("input");
    fileInput.type = "file";
    fileInput.accept = ".glb,.gltf";
    fileInput.className = "mb-2";


    const captionInput = document.createElement("input");
    captionInput.type = "text";
    captionInput.placeholder = "Beschreibung (z. B. Macintosh Classic 1982)";
    captionInput.value = this.data.alt || "";
    captionInput.className = "w-full border p-2 rounded mb-2";

    captionInput.addEventListener("input", (e) => {
      this.data.alt = e.target.value;
    });

    this.wrapper.appendChild(captionInput);


    const preview = document.createElement("model-viewer");
    preview.alt = this.data.alt || "3D Preview";
    preview.autoRotate = true;
    preview.cameraControls = true;
    preview.setAttribute("ar", "");
    preview.setAttribute("ios-src", this.data.src);
    preview.setAttribute("exposure", "1.0");
    preview.setAttribute("shadow-intensity", "1");
    preview.setAttribute("camera-orbit", "0deg 75deg 2.5m");
    preview.setAttribute("auto-rotate-delay", "1000");
    preview.setAttribute("interaction-prompt", "when-focused");
    preview.setAttribute("interaction-prompt-style", "basic");
    preview.setAttribute("style", "width:100%; height:400px;");
    preview.setAttribute("reveal", "auto");
    preview.setAttribute("loading", "eager");
    preview.setAttribute("ar-modes", "scene-viewer webxr quick-look");
    preview.setAttribute("fullscreen-button", "");

    // -- Event Listeners
    input.addEventListener("input", (e) => {
      this.data.src = e.target.value;
      preview.src = e.target.value;
      preview.setAttribute("ios-src", e.target.value);
    });

    fileInput.addEventListener("change", async (e) => {
      const file = e.target.files[0];
      if (!file) return;

      if (file.size > 15 * 1024 * 1024) {
        alert("🚫 Datei zu groß! Bitte unter 15 MB.");
        return;
      }

      input.disabled = true;
      input.value = "⬆️ Upload läuft...";

      try {const url = await uploadToServer(file);
        this.data.src = url;
        input.value = url;
        preview.src = url;
        preview.setAttribute("ios-src", url);
      } catch (err) {
        input.value = "❌ Upload fehlgeschlagen";
        console.error(err);
      } finally {
        input.disabled = false;
      }
    });

    this.wrapper.appendChild(info);
    this.wrapper.appendChild(fileInput);
    this.wrapper.appendChild(input);
    this.wrapper.appendChild(preview);

    return this.wrapper;
  }

  save() {
    return this.data;
  }

  static get toolbox() {
    return {
      title: "3D Upload",
      icon: "🧊",
    };
  }
}


